
/* Core Of Corporate premium interactions: progressive enhancement, scoped and accessible */
(function(){
  function init(section){
    if(!section||section.dataset.cocInitialized==='true')return;
    section.dataset.cocInitialized='true';
    const cards=[...section.querySelectorAll('[data-coc-category]')];
    const buttons=[...section.querySelectorAll('[data-coc-filter]')];
    const status=section.querySelector('[data-coc-status]');
    const labels={all:'All three toolkits',survival:'First job toolkit',comms:'Communication toolkit',switch:'Company switch toolkit'};
    function setFilter(value){
      const option=Object.prototype.hasOwnProperty.call(labels,value)?value:'all';
      buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.cocFilter===option)));
      let shown=0;
      cards.forEach(card=>{const match=option==='all'||card.dataset.cocCategory===option;card.hidden=!match;if(match)shown++;});
      if(status)status.textContent=labels[option]+' — '+shown+' '+(shown===1?'kit':'kits')+' shown';
      section.querySelectorAll('[data-coc-finder-choice]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.cocFinderChoice===option)));
    }
    buttons.forEach(b=>b.addEventListener('click',()=>setFilter(b.dataset.cocFilter)));
    section.querySelectorAll('[data-coc-finder-choice]').forEach(b=>b.addEventListener('click',()=>{
      const value=b.dataset.cocFinderChoice;setFilter(value);
      const catalog=section.querySelector('#coc-kits');
      if(catalog)catalog.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    }));
    const reveals=[...section.querySelectorAll('.coc-reveal')];
    if('IntersectionObserver' in window&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.add('coc-in');observer.unobserve(entry.target);}
      }),{threshold:.08,rootMargin:'0px 0px 70px 0px'});
      reveals.forEach(el=>observer.observe(el));
      section.classList.add('coc-motion-ready');
    }
  }
  function boot(ctx){const root=ctx||document;root.querySelectorAll('.coc-main').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
  let busy=false;
  window.addEventListener('scroll',()=>{if(!busy){requestAnimationFrame(()=>{document.documentElement.classList.toggle('coc-header-scrolled',window.scrollY>12);busy=false;});busy=true;}},{passive:true});
})();
